// ChatStyle.js
import styled from "styled-components";

export const ChatParent = styled.div`
  height:calc(100vh - 130px);
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
  overflow: auto;
  background:#FFFFFF;
  position:relative;
  /* border:1px solid #CCC; */
  border-radius:10px;
  padding:5px 0;

  .message-send-button{
    padding:5px 15px ;
    background: #2e59e6;
    border: 0;
    border-radius: 50px;
    color:#FFFFFF;
    cursor: pointer;
    max-height: 60px;
  }
  
  .message-send-button-icon{
    width: 25px;
    height: 25px;
  }
  
  .ai-sub-text{
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.5px;
    color:#696969;
  }

  .ai-menu-container{
    position: absolute;
    right: 20px;
    top: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    z-index:100;
  }

  .ai-menu-icon-container{
    width: 40px;
    height: 40px;
    border: 1px solid #CCC;
    background:#FFFFFF;
    border-radius: 50%;
    padding: 8px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .ai-menu-button-list{
    width: 250px;
    display: flex;
    flex-direction: column;
    border: 1px solid #CCC;
    padding: 10px 5px;
    border-radius: 5px;
    margin-left: 2px;
    background: rgba(255,255,255,0.1);
    backdrop-filter: blur(10px); /* Blur effect */
    -webkit-backdrop-filter: blur(10px); /* For Safari */
    position: absolute;
    top: 105%;
    right: 0;
    transform: scale(0);
    transform-origin: top right;
    opacity: 0;
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
    z-index: 10;
  }

  .ai-menu-drop-down-options{
    padding: 5px 10px;
    margin: 0;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 400;
    letter-spacing: 0.5px;
    cursor: pointer;
  }

  .ai-menu-drop-down-options:hover{
    background: rgba(120,120,120,0.1);
    font-weight: 500;
  }

  .red-color-text{
    color:red;
  }


.ai-menu-container:hover .ai-menu-button-list {
    transform: scale(1);
    opacity: 1;
}

.ai-user-prompt-modal{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(2px); /* Blur effect */
    -webkit-backdrop-filter: blur(2px); /* For Safari */
    z-index: 999999999999999999;
    display:flex;
    align-items:center;
    justify-content:center;
}

.ai-prompt-parent{
    border:1px solid #CCC;
    padding:20px;
    border-radius:20px;
    background:#FFFFFF;
    width:fit-content;
    display:flex;
    flex-direction:column;
    gap:10px;
}

.ai-prompt-title{
    padding:0;
    margin:0;
    font-size:18px;
    font-weight:500;
    letter-spacing:0.5px;
}

.ai-prompt-input{
    background: #eff0f1;
    resize:none;
    border-radius:10px;
    height:70vh;
    width:30vw;
    outline:none;
    border:1px solid #ccc;
    padding:10px 10px;
    font-size:14px;
    font-weight:400;
    letter-spacing:0.5px;
    font-family: sans-serif;
}

.ai-prompt-button-container{
    display:flex;
    justify-content:right;
    align-items:center;
    gap:10px;
    padding:0;
    margin:0;
}

.ai-prompt-secondary-button{
    padding:5px 20px;
    border:1px solid #CCCCCC;
    border-radius:50px;
    font-size:14px;
}

.ai-prompt-primary-button{
    padding:5px 20px;
    border:1.5px solid #2e59e6;
    border-radius:50px;
    font-size:14px;
    background:#2e59e6;
    color:#FFFFFF;
}


.ai-file-container{
  border:2px dashed #ccc;
  height:100%;
  padding:20px 30px;
  border-radius:10px;
  display:flex;
  align-items:center;
  flex-direction:column;
  justify-content:center;
  gap:20px;
  user-select:none;
  background:#FFFFFF;
}

.ai-file-upload-icon{
  width:45px;
  height:45px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  background:#eaeaeb;
}

.ai-uploader-text-container{
  display:flex;
  flex-direction:column;
  gap:5px;
  align-items:center;
}

.ai-text-14{
  font-size:16px;
}

.ai-highlighted-text{
  color:#2e59e6;
  font-weight:500;
  cursor:pointer;
}

.ai-uploader-sub-text{
  font-size:10px;
  color:#b4b4d3;
}

.ai-upload-remove-icon{
  font-size:14px;
  margin-left:10px;
  padding:3px 5px;
  background:rgba(239, 68, 68, 0.3);
  color:rgba(239, 68, 68, 1);
  border-radius:5px;
}

.ai-w-full{
  width:100%;
  display:flex;
  justify-content:center;
  align-items:center;
}

.ai-file-inner-container{
  display:flex;
  align-items:center;
  flex-direction:column;
  justify-content:center;
  gap:20px;
}

.ai-button-text{
  color:#FFFFFF;
  font-size:14px;
  margin-left:10px;
  font-weight:600;
}

.ai-file-analys-text{
  font-size:16px;
  font-weight:600;
}

.ai-file-scaning-animation-contaier{
  display:flex;
  flex-direction:column;
  align-items:center;
  gap:20px;
}

.ai-back-icon-container{
  position:absolute;
  left: 20px;
  top: 20px;
  display: flex;
  padding:5px 5px;
  border-radius:50%;
  cursor:pointer;
}

.ai-display-parent-container{
  height:100%;
  width:100%;
  padding:60px 30px;
  display:flex;
  flex-direction:column;
  gap:20px;
  overflow:auto;
}

.ai-result-chat-container{
  font-size:20px;
  font-weight:700;
  letter-spacing:0.5px;
  color:#344054;
}

.ai-msg-container{
  padding:20px 30px;
  border:1px solid #CCC;
  width:100%;
  border-radius:10px;
  background:#FFFFFF;
  /* white-space: pre-wrap;  
  word-wrap: break-word;   */
}

table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  border: 1px solid #ccc;
  padding: 8px;
}
th {
  background-color: #f5f5f5;
}

.ai-copy-button-container{
  display:flex;
  align-items:center;
  justify-content:right;
}

  /* Animations */

  @keyframes wave {
  0% { transform: rotate(0deg); }
  20% { transform: rotate(10deg); }
  40% { transform: rotate(-10deg); }
  60% { transform: rotate(10deg); }
  80% { transform: rotate(-10deg); }
  100% { transform: rotate(0deg); }
}

.wave {
  display: inline-block;
  font-size: 40px;
  animation: wave 1.5s infinite;
  transform-origin: 70% 70%; /* Adjusts pivot point for realistic waving */
}

    .typing-indicator {
            display: flex;
            align-items: center;
            gap: 5px;
            width: fit-content;
        }

        .typing-indicator span {
            width: 10px;
            height: 10px;
            background-color: #b4b4d3;
            border-radius: 50%;
            animation: bounce 1.5s infinite ease-in-out;
        }

        .typing-indicator span:nth-child(1) {
            animation-delay: 0s;
        }

        .typing-indicator span:nth-child(2) {
            animation-delay: 0.2s;
        }

        .typing-indicator span:nth-child(3) {
            animation-delay: 0.4s;
        }

        @keyframes bounce {
            0%, 80%, 100% {
                transform: translateY(0);
            }
            40% {
                transform: translateY(-8px);
            }
        }

        .scanner-container {
      position: relative;
      width: 150px;
      height: 200px;
      background: #1e293b;
      border-radius: 10px;
      box-shadow: 0 0 15px #0ea5e9;
      overflow: hidden;
    }

    .file-icon {
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, #334155 50%, #475569 50%);
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-family: sans-serif;
      font-size: 20px;
      letter-spacing: 1px;
      position: relative;
    }

    .scan-line {
      position: absolute;
      top: -100%;
      left: 0;
      width: 100%;
      height: 50%;
      background: rgba(14, 165, 233, 0.2);
      border-top: 2px solid #0ea5e9;
      border-bottom: 2px solid #0ea5e9;
      animation: scan 2s infinite linear;
    }

    @keyframes scan {
      0% {
        top: -50%;
      }
      100% {
        top: 100%;
      }
    }
`;